import { render, staticRenderFns } from "./PurchaseMinimum.vue?vue&type=template&id=afa8db12&scoped=true&"
import script from "./PurchaseMinimum.vue?vue&type=script&lang=js&"
export * from "./PurchaseMinimum.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseMinimum.vue?vue&type=style&index=0&id=afa8db12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa8db12",
  null
  
)

export default component.exports